import React from 'react';
import { Badge, Button, Col, Icon, message, Row, Tag, Popconfirm, Input, Popover } from 'antd';
import { connect } from 'react-redux';

import WhiteLabelModal from '../white-label-editor';

import { API_ENDPOINT } from '../../../index';

import { 
    _getSupplierInformation, 
    _postVerificationBoolean,
} from '../actions';

import EditSupplierDetails from './edit-supplier-details';
import VerifyModal from './verify-modal';
import AddressForm from '../../orders-v2/addressForm'

import { 
    _postResetUniqId,
    _postSaveWhiteLabelSettings, 
    _postToggleShopActive, 
    _postToggleFlaggedForDelete,
    _postToggleSuspended,
    _postEditSupplierDetails,
    _postSaveStockUpdateConfig,
    _postSupplierAlternateEmail,
    _postSupplierAlternateAddress,
    _getCanDevLogin
} from '../../../services';

class ProfileHeader extends React.Component {

    
    render() { 
        const { supplierId } = this.props;
        const { supplier, supplierName, supplierDetails, supplierAlternateEmail } = this.state;

        const bankInfoDocument =    (this.state.supplier.verification && 
                                    this.state.supplier.verification.bankInfo && 
                                    this.state.supplier.verification.bankInfo.document) || false,
           companyProfileDocument = (this.state.supplier.verification && 
                                    this.state.supplier.verification.companyProfile && 
                                    this.state.supplier.verification.companyProfile.document) || false,
         isAccountingInfoVerified = this.state.isAccountingInfoVerified || false,
            isCompanyInfoVerified = this.state.isCompanyInfoVerified|| false;

        if( !supplier ) {
            return(<div>Loading...</div>)
        } 

        const flaggedForDelete = this.state.supplier.flaggedForDelete;
        const suspended = this.state.supplier.suspended;

        console.log({
            suspended: suspended,
            state: this.state.supplier.suspended
        })

        return (
            <div>
                <Row type="flex" justify="space-between">
                    <Col>
                        {(supplierName === '')? 
                            <div className="supplier-name" style={{fontStyle: 'italic'}}> Without Name </div>
                        :
                            <div className="supplier-name" >
                                {supplierName}
                            </div>
                        }
                    </Col>
                    
                    <Col>
                        <Row gutter={8} type={"flex"}>

                            <Col>
                                {this.state.canDevLogin && 
                                    <Button href={`${API_ENDPOINT}/api/admin/developer/login/${supplierId}`}>
                                        Developer Login
                                    </Button>
                                }
                            </Col>

                            {/* <Col>
                                <Button 
                                    ghost 
                                    type={shopActive?"danger":"primary"} 
                                    onClick={this.handleDisableStore}>
                                    {shopActive?"Disable Shop":"Activate Shop"}
                                </Button>
                            </Col> */}

                            <Col>
                                <Button 
                                    type={flaggedForDelete?"danger":"default"} 
                                    onClick={this.handleFlagForDelete}>
                                    {flaggedForDelete?"Un-Flag For Delete":"Flag For Delete"}
                                </Button>
                            </Col>
                            
                            <Col>
                                <Popconfirm
                                    title={suspended
                                        ? "Supplier will be unsuspended, all their items will be restored to their previous active status"
                                        : "Supplier will be suspended, all their items will be set to inactive temporarily"
                                    }
                                    onConfirm={this.handleSuspend}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        type={suspended?"danger":"default"}>
                                        {suspended?"Unsuspend":"Suspend"}
                                    </Button>
                                </Popconfirm>
                            </Col>

                            <Col>
                                <Popover
                                    trigger="click"
                                    content={
                                        <Row>
                                            <Col>
                                                <Row gutter={16} type="flex" align="middle" >
                                                    <Col>
                                                        <h3>Stock Count Approved Email:</h3>
                                                    </Col>
                                                    <Col>
                                                        <Button 
                                                            onClick={ this.handleStockCountApprovedEmail_add } 
                                                            style={{ marginBottom: "0.5em"}} type="primary" shape="circle" icon="plus"/>
                                                    </Col>
                                                </Row>
                                                {this.state.supplier.shop.stockCountApprovedEmail.map(
                                                    (email, row) => (
                                                        <Row type="flex" style={{ marginBottom: 8 }}>
                                                            <Col>
                                                                <Input onChange={ e => this.handleStockCountApprovedEmail_edit(row, e.target.value)} value={email}/>
                                                            </Col>

                                                            <Col>
                                                                <Button onClick={ () => this.handleStockCountApprovedEmail_remove( row )} icon="close"/>
                                                            </Col>
                                                        </Row>
                                                    )
                                                )}
                                                
                                                <br/>

                                                <h3>Stock Count Start Row:</h3>
                                                <Input
                                                    name="stockCountExcelRowStart"
                                                    onChange={ this.handleStockCountGeneralDetails_edit }
                                                    value={this.state.supplier.shop.stockCountExcelRowStart}
                                                    /><br/>
                                                
                                                <h3>Stock Count supplierSku Column:</h3>
                                                <Input
                                                    name="stockCountExcelSupplierSkuColumn"
                                                    onChange={ this.handleStockCountGeneralDetails_edit }
                                                    value={this.state.supplier.shop.stockCountExcelSupplierSkuColumn}
                                                    /><br/>
                                                
                                                <h3>Stock Count Quantity Column:</h3>
                                                <Input
                                                    name="stockCountExcelQuantityColumn"
                                                    onChange={ this.handleStockCountGeneralDetails_edit }
                                                    value={this.state.supplier.shop.stockCountExcelQuantityColumn}
                                                    /><br/>
                                                
                                                <Button
                                                    onClick={ this.handleStockConfig_save } 
                                                    style={{ marginTop: 16, width: "100%" }} 
                                                    type="primary">SAVE CONFIG</Button>
                                            </Col>
                                        </Row>
                                    }>
                                    <Button>
                                        Automatic Stock Update Config
                                    </Button>
                                </Popover>
                            </Col>

                            <Col>
                                <Popover
                                    trigger="click"
                                    content={
                                    <Row>
                                        <Row>
                                            Email
                                        </Row>
                                        <Row>
                                            <Input
                                                defaultValue={supplierAlternateEmail}
                                                onChange={(e)=>this.setState({supplierAlternateEmail: e.target.value})}
                                                placeholder="alternate@gmail.com"
                                            />
                                        </Row>
                                        <Row type="flex" justify="end">
                                            <Button
                                                onClick={this.handleCreateAlternateEmail}
                                            >
                                                Submit
                                            </Button>
                                        </Row>
                                    </Row>}>
                                    <Button
                                        ghost 
                                        type="primary">
                                        Alternate Email
                                    </Button>
                                </Popover>
                            </Col>

                            <Col>
                                <Button onClick={this.handleVerifyInformation} >
                                    Verify Information
                                </Button>
                            </Col>

                            <Col>
                                <Popconfirm title="Please ask tech team before using this. Actions are logged." onConfirm={ this.handleResetUniqId }>
                                    <Button type="danger">
                                        RESET 10 DIGIT SHOP ID
                                    </Button>
                                </Popconfirm>
                            </Col>

                            {/* <Col>
                                <Button onClick={ () => this.handleWhiteLabelModalVisiblity( true ) } >
                                    White Label
                                </Button>
                            </Col> */}

                        </Row>
                    </Col>
                    

                </Row>

                <Row>
                    
                </Row>

                <Row type="flex">

                   <Col span={15}>
                        <Row>
                            <Col> 
                                {supplierDetails.uen} 
                            </Col>

                            <Col>
                                <Tag color={(supplierDetails.gstRegistered)? 'green' : '#A9A9A9'}>
                                    GST
                                </Tag>
                            </Col>

                            <Col>
                                <Tag>
                                    {supplier.shop.shopCountry}
                                </Tag>
                            </Col>
                        </Row>

                            
                            <Row style={{paddingTop: '30px', fontWeight: '600', fontSize: '14px'}}>
                                Details
                               {supplier.ghost && <Popover 
                                    title="Edit details"
                                    trigger="click"
                                    content={
                                        <Row>
                                            <Row>
                                                Name
                                            </Row>
                                            <Row>
                                                <Input
                                                    defaultValue={supplierDetails.name}
                                                    onChange={(e)=>this.handleEditSupplierDetails({
                                                        value: e.target.value,
                                                        key: 'name'
                                                    })}
                                                    // placeholder="alternate@gmail.com"
                                                />
                                            </Row>
                                            <Row>
                                                Email
                                            </Row>
                                            <Row>
                                                <Input
                                                    defaultValue={ supplierDetails.email}
                                                    onChange={(e)=>this.handleEditSupplierDetails({
                                                        value: e.target.value,
                                                        key: 'email'
                                                    })}
                                                    // placeholder="alternate@gmail.com"
                                                />
                                            </Row>
                                            <Row>
                                                Hp
                                            </Row>
                                            <Row>
                                                <Input
                                                    defaultValue={ supplierDetails.hp}
                                                    onChange={(e)=>this.handleEditSupplierDetails({
                                                        value: e.target.value,
                                                        key: 'hp'
                                                    })}
                                                />
                                            </Row>
                                            <Row type="flex" justify="end">
                                                <Button
                                                    onClick={this.handleSubmitEditSupplierDetails}
                                                >
                                                    Submit
                                                </Button>
                                            </Row>
                                        </Row>
                                        }
                                    >
                                    <Icon 
                                    style={{cursor: 'pointer'}}
                                    type="edit"/>
                                </Popover>}
                            </Row>
                            <Row type="flex" gutter={16}>
                                <Col>
                                {this.renderDetails(supplierDetails)}
                                </Col>
                            </Row>
                             <Row style={{paddingTop: '30px', fontWeight: '600', fontSize: '14px'}}>
                                Address 
                                <Popover
                                    trigger="click"
                                    content={
                                    <AddressForm
                                        alt
                                        setAlternateAddress={this.handleSubmitAltAddress}
                                    />
                                    }
                                >
                                <Icon type="edit"/>
                                </Popover>
                            </Row>
                            <Row type="flex" gutter={16}>
                                <Col>
                                    {this.renderAddress(supplierDetails)}
                                </Col>
                                <Col>
                                    {supplier.addressAlt && 
                                    <Row>
                                    {this.renderAddress(supplier.addressAlt)}
                                    <Tag>Alternate</Tag>
                                    </Row>
                                    }
                                </Col>
                            </Row>

                            <Row className="details-row" type="flex" gutter={25}>
                                <a target={`bank_details_${supplier._id}`} disabled={!bankInfoDocument} href={ bankInfoDocument }>
                                    <Icon type="bank" />  Bank Details <Badge status={(isAccountingInfoVerified)? "success" : "default"} />
                                </a>
                                <a target={`company_details_${supplier._id}`} disabled={!companyProfileDocument} href={ companyProfileDocument }>
                                    <Icon type="solution" /> Company Details <Badge status={(isCompanyInfoVerified)? "success" : "default"} />
                                </a>
                            </Row>

                   </Col>

                   <Col span={9} className="mov-input">
                        <Col> </Col>

                        <Col> 
                            <EditSupplierDetails 
                                supplierId={supplier._id}
                                remarks={supplier.remarks || ''}
                                movAmount={supplier.shop.movFreeDelivery || 0}
                                />
                        </Col>
                    </Col>
                </Row>


                <VerifyModal 
                    supplier={this.state.supplier} 
                    handleCancel={this.handleModalCancel} 
                    modalVisible={this.state.modalVisible} 
                    handleOk={this.handleOnOk}
                    supplierId={supplierId}
                    loading={this.state.loading}/>

                <WhiteLabelModal 
                    supplier={ this.state.supplier }
                    handleOk={ this.handleWhiteLabelOnSaveSettings }
                    modalVisible={this.state.whiteLabelModalVisible} 
                    handleCancel={ () => this.handleWhiteLabelModalVisiblity( false ) } 
                    />
            </div>
        )
    }

    constructor( props ) {
        super(props);

        this.state = {
            supplierId: props.supplierId,
            supplierName: false,
            supplier: false,
            supplierDetails: false,
            modalVisible: false,
            loading: false,
            isAccountingInfoVerified: false,
            isCompanyInfoVerified: false,
            whiteLabelModalVisible: false,
            supplierAlternateEmail: false,
            // supplierAlternateDetails: false,
            // setSupplierAlternateEmail: false,
            supplierAlternateAddress:false,
            // tempId: '5a203670735a7d0cbca50f29',
            canDevLogin: false
        }
    }

    componentWillMount() {

        Promise.all([
            _getSupplierInformation(this.state.supplierId),
            _getCanDevLogin(`${this.props.user.data._id}`)
        ])
            .then(([res, canDevLogin]) => {

                let { verification } = res.data.supplier;
                
                        verification = verification || {};

                const   isAccountingInfoVerified = (verification && verification.bankInfo && verification.bankInfo.approve) || false,
                        isCompanyInfoVerified = (verification && verification.companyProfile && verification.companyProfile.approve) || false;

                this.setState({
                    supplierName: res.data.supplier.details.companyName,
                    supplier: res.data.supplier,
                    supplierDetails: res.data.supplier.details,
                    supplierAlternateEmail: res.data.supplier.alternateEmail,
                    // supplierAlternateDetails: res.data.supplier.detailsAlt,
                    supplierAlternateAddress: res.data.supplier.addressAlt,
                    isAccountingInfoVerified,
                    isCompanyInfoVerified,
                    canDevLogin: canDevLogin.data
                })

                this.props.onUpdate(res.data.supplier.details.companyName)
            })
    }

    handleSubmitAltAddress = ( address ) => {

        let { supplierId } = this.state

        // console.log(address)

        _postSupplierAlternateAddress({
            address,
            supplierId
        })
        .then( res => {

            this.setState({supplierAlternateAddress: res.data.alternateAddress})
            message.success("Successfully set alternate address!")
        })
    }

    handleEditSupplierDetails = ({value, key})=>{

        let details = {...this.state.supplierDetails}

        details[key] = value.trim()

        this.setState({supplierDetails: details})
    }

    handleSubmitEditSupplierDetails = () =>{

        let { supplierDetails, supplierId } = this.state 

        let valid = true

        // eslint-disable-next-line no-useless-escape
        let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let hpRegex = /[0-9]/
        
        const email = supplierDetails.email

        if(!emailRegex.test(email)){

            message.warning("Please input a valid email")
            valid = false

        } 

        if(!hpRegex.test(supplierDetails.hp)){
            message.warning("Please input a valid hp")
            valid = false
        }

        if(valid){

            _postEditSupplierDetails({details : supplierDetails, supplierId})
            .then( res => {

                // console.log(res)
                const { supplier } = res.data

                message.success("Successfully set alternate details!")

                this.setState({supplier, supplierDetails: supplier.details})
            })

        }

    }

    handleCreateAlternateEmail = () =>{

        let { supplierAlternateEmail, supplierId } = this.state 

        // eslint-disable-next-line no-useless-escape
        let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        const email = supplierAlternateEmail.trim()

        if(!regex.test(email)){

            message.warning("Please input a valid email")

        } else {

            _postSupplierAlternateEmail({
                email,
                supplierId
            })
            .then( res => {

                // console.log(res)

                message.success("Successfully set alternate email!")

                this.setState({supplierAlternateEmail: res.data.alternateEmail, setSupplierAlternateEmail: true})
            })

        }

    }

    handleDisableStore = () => {

        message.loading("Updating shop...");

        _postToggleShopActive({ userId: this.state.supplierId })
            .then( res => {

                message.destroy();
                message.success("Shop Updated!");

                this.setState({
                    supplier: {
                        ...this.state.supplier,
                        shop: {
                            ...this.state.supplier.shop,
                            active: res.data.active
                        }
                    }
                });

            })
            .catch( res => {
                
                message.error("Oops there was an error.. Please contact IT support.");

            })
    }

    handleFlagForDelete = () => {

        message.loading("Updating Supplier...");

        _postToggleFlaggedForDelete({ userId: this.state.supplierId })
            .then( res => {

                message.destroy();
                message.success("Supplier Updated!");

                this.setState({
                    supplier: {
                        ...this.state.supplier,
                        flaggedForDelete: res.data.flaggedForDelete
                    }
                });

            })
            .catch( res => {
                
                message.error("Oops there was an error.. Please contact IT support.");

            })
    }

    handleSuspend = () => {

        message.loading("Updating Supplier...");

        _postToggleSuspended({ 
            userId: this.state.supplierId,  
            suspended: !this.state.supplier.suspended
        })
            .then( res => {

                message.destroy();
                message.success("Supplier Updated!");

                this.setState({
                    supplier: {
                        ...this.state.supplier,
                        suspended: res.data.suspended
                    }
                });

                if (this.props.onRefreshProducts) {
                    this.props.onRefreshProducts();
                }

            })
            .catch( res => {
                
                message.error("Oops there was an error.. Please contact IT support.");

            })
    }

    handleModalCancel = () => {
        this.setState({
            modalVisible: false
        })
    }

    handleOnOk = ( isAccountingInfoVerified, isCompanyInfoVerified ) => {
        this.setState({
            loading: true
        });

        _postVerificationBoolean(this.state.supplierId, isAccountingInfoVerified, isCompanyInfoVerified)

        setTimeout(() => {
            // console.log(isCompanyInfoVerified)
            this.setState({
                loading: false,
                modalVisible: false,
                isAccountingInfoVerified,
                isCompanyInfoVerified
            })
        },500)
    }

    handleWhiteLabelModalVisiblity = ( whiteLabelModalVisible ) => {

        this.setState({ whiteLabelModalVisible });

    }

    
    handleResetUniqId = () => {

        const { supplierId } = this.state;

        _postResetUniqId( supplierId )
            .then( res => {
                message.success(`Reset uniq id to ${res.data.uniqId}`);
            })
            .catch( err => {
                message.error(`Oops there was an error. Please notify tech team.`);
            });
    }

    handleStockConfig_save = () => {

        message.loading("Saving config...", 0);

        const {
            stockCountApprovedEmail,
            stockCountExcelQuantityColumn,
            stockCountExcelRowStart,
            stockCountExcelSupplierSkuColumn
        } = this.state.supplier.shop;

        const supplierId = this.state.supplier._id;

        _postSaveStockUpdateConfig({
            supplierId,
            stockCountApprovedEmail,
            stockCountExcelRowStart,
            stockCountExcelQuantityColumn,
            stockCountExcelSupplierSkuColumn
        })
            .then( res => {

                message.destroy();
                message.success("Config updated successfully");

                this.setState({
                    supplier: {
                        ...this.state.supplier,
                        shop: res.data.shop
                    }
                });
            })

    }

    handleStockCountApprovedEmail_add = () => {
        this.setState({
            supplier:{
                ...this.state.supplier,
                shop: {
                    ...this.state.supplier.shop,
                    stockCountApprovedEmail: [
                        ...this.state.supplier.shop.stockCountApprovedEmail,
                        ""
                    ]
                }
            }
        });
    }

    handleStockCountApprovedEmail_edit = ( row, value ) => {
        this.setState({
            supplier:{
                ...this.state.supplier,
                shop:{
                    ...this.state.supplier.shop,
                    stockCountApprovedEmail: [
                        ...this.state.supplier.shop.stockCountApprovedEmail.map( ( email, index ) => {

                            if( index === row ){
                                return value.trim();
                            }

                            return email;

                        })
                    ]
                }
            }
        })

    }

    handleStockCountApprovedEmail_remove = ( row ) => {
        this.setState({
            supplier:{
                ...this.state.supplier,
                shop:{
                    ...this.state.supplier.shop,
                    stockCountApprovedEmail: [
                        ...this.state.supplier.shop.stockCountApprovedEmail.filter( ( email, index ) => index !== row )
                    ]
                }
            }
        })
    }

    handleStockCountGeneralDetails_edit = ( e ) => {


        if(  isNaN(e.target.value) ){
            message.destroy();
            return message.error("Value must be a number!");
        }

        this.setState({
            supplier:{
                ...this.state.supplier,
                shop:{
                    ...this.state.supplier.shop,
                    [e.target.name]: e.target.value
                }
            }
        })
    }
    
    handleVerifyInformation = () => {
        this.setState({
            modalVisible: true
        })
    }
    
    handleWhiteLabelOnSaveSettings = ( whiteLabelSettings ) => {
        
        _postSaveWhiteLabelSettings({
            whiteLabelSettings,
            userId: this.state.supplierId
        })
            .then( res => {

                console.log("saved");

            })

    }

    renderAddress = (address) =>{
        return (
            <Row>
                <Row>
                    {address.address} {`| ${address.unit}`}
                </Row>

                <Row>
                    {address.postalCode}
                </Row>
            </Row>
        )
    }

    renderDetails=(details)=>{
        return (
            <Row>
                <Row>
                    {details.name}
                </Row>

                <Row>
                    {`${details.email }  |  ${details.hp}`} 
                </Row>
            </Row>
        )
    }
    
}

export default connect( 
	state => ({
		user: state.user
	})
 )( ProfileHeader );


// WEBPACK FOOTER //
// ./src/components/supplier-profile/profile-header/index.js